import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const useOnLanguageChange = (callback: () => void, deps: any[] = []) => {
  const {
    i18n: { language: lang },
  } = useTranslation();

  useEffect(() => {
    if (!lang) {
      return;
    }

    callback();
  }, [lang, ...deps]);
};

export default useOnLanguageChange;
